// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

const app = createApp(App);
app.use(router);

// 添加导航守卫以动态设置标题
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'xiaoyang的个人网站'; // 如果没有 meta.title，则使用默认标题
  next();
});

app.mount('#app');
